var isDeviceMobile = window.matchMedia('(max-width: 85.375rem)').matches;

var body = document.querySelector('body');
var header = document.getElementById('header');
